import React from 'react';
import cx from 'classnames';
import Proptypes from 'prop-types';

import { ORDERED_LIST_DEFINITIONS } from '@xingternal/content-editor-plugin-helpers';

import { ORDERED_LIST_TAG_NAME } from './constants';
import styles from './OrderedList.css';

const renderer = ({
  node: { type },
  ORDERED_LIST_TAG = ORDERED_LIST_TAG_NAME,
  ...attributes
}) => {
  if (type === ORDERED_LIST_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return (
      <ORDERED_LIST_TAG
        {...restOfAttributes}
        className={cx(styles.orderedList, attributes.className)}
        data-editor-plugin="orderedList"
      >
        {children}
      </ORDERED_LIST_TAG>
    );
  }
};

renderer.Proptypes = {
  node: Proptypes.object,
  attributes: Proptypes.object,
};

export { renderer };
